module.exports = __webpack_public_path__ + "img/home_header_mobile_1.cb2ba3e6.jpg";